import { useQuery } from '@tanstack/react-query'

import { useQueryErrorAlert } from '@hooks/useQueryErrorAlert'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import { fetchKlantAdditioneleVragen } from '../services/fetchKlantAdditioneleVragen'

export { useKlantAdditioneleVragen }

const queryKey = 'klant-additionelevragen'

const useKlantAdditioneleVragen = ({ id }: { id: string }) => {
  const { hasPermissions } = useAuthenticatedUser()

  const {
    data,
    isPending: isLoading,
    error,
    errorUpdatedAt,
  } = useQuery({
    queryKey: [queryKey, id],
    queryFn: () => fetchKlantAdditioneleVragen({ id }),
    enabled: hasPermissions && !!id,
    refetchOnMount: true,
  })

  useQueryErrorAlert(
    error,
    errorUpdatedAt,
    'Fout bij ophalen van additionele vragen',
  )

  return {
    data: data || [],
    isLoading,
  }
}
